<template>
  <div class="result-target">
    <div class="result-target__item">
      <span class="result-target__label">
        7分
      </span>
      <a-textarea
        class="result-target__input"
        :class="isError ? 'wrongBox':''"
        style="min-height: 40px; line-height: 30px; position: relative; z-index: 1;"
        placeholder="输入内容"
        maxlength="1000"
        autosize
        :value="sevenTarget"
        @blur="(e) => formateInput('sevenTarget', e.target.value)"
        @change="(e) => handleInputChange('sevenTarget', e.target.value)"
        @focus="(e) => handleInputClear('sevenTarget', e.target.value)"
      />
    </div>
    <div class="result-target__item">
      <span class="result-target__label">
        10分
      </span>
      <a-textarea
        class="result-target__input"
        style="min-height: 40px; line-height: 30px;"
        placeholder="输入内容"
        maxlength="1000"
        autosize
        :value="tenTarget"
        @blur="(e) => formateInput('tenTarget', e.target.value)"
        @change="(e) => handleInputChange('tenTarget', e.target.value)"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input } from 'ant-design-vue'

Vue.use(Input)

// result 的目标值
export default {
  name: '',
  components: {},
  props: {
    // 十分目标
    tenTarget: {
      type: String,
      default: '',
    },
    // 七分目标
    sevenTarget: {
      type: String,
      default: '',
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    /**
     * Input change 事件
     * @param {String} name 字段名称
     * @param {String} v 值
     */
    handleInputChange(name, v) {
      this.$emit('change', name, v)
    },
    /**
     * Input 格式化文本，多个空格合并成一个，并加入数组
     * @param {String} name 字段名称
     * @param {String} v 值
     */
    formateInput(name, v) {
      v = v.replace(/[ ]+/g, ' ')
      this.$emit('change', name, v)
    },
    handleInputClear(name, v) {
      if (this.isError) {
        v = ''
        this.$emit('change', name, v)
        this.$emit('myFocus')
      }
    },
  },
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';

@borderRadius: 4px;

.result-target {
  min-width: 250px;
  &__item {
    display: flex;
    .result-target__input{border-radius: 0; position: relative;
    &:hover,&:focus{z-index: 2;}
    }
    &:first-child {
      .result-target__label {
        border-top-left-radius: @borderRadius;
        border:#d9d9d9 solid;
        border-width: 1px 0 0 1px;
        position: relative;
        &::after{content: ""; position: absolute; left:0; right:0; bottom:0; height: 1px; background: #d9d9d9;}
      }
      .result-target__input {
        border-top-right-radius: @borderRadius;
      }
    }

    &:last-child {
      .result-target__label {
        border:#d9d9d9 solid;
        border-width:0 0 1px 1px;
        border-bottom-left-radius: @borderRadius;
      }
      .result-target__input {
        margin-top:-1px;
        border-bottom-right-radius: @borderRadius;
      }
    }
  }
  &__label {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 40px;
    width: 40px;
    font-weight: 500;
  }
}
</style>
